// extracted by mini-css-extract-plugin
export default {"wrapperClasss":"styles_wrapperClasss__8mqz4","fullWidth":"styles_fullWidth__+p5Sk"};